module.exports = __webpack_public_path__ + "img/enhanced-dollar.65a95b9d.svg";